<template>
  <div class="content" v-if="applicantInfoData">
    <applicant-info></applicant-info>
    <round-info :slug="this.$route.params.slug"></round-info>
    <comments-section></comments-section>
    <follow-up-status />
    <email-conversation
      v-if="
        hasAccess({
          permissions: [PERMISSIONS.MAIL.MENU],
          checkAll: false,
        })
      "
    ></email-conversation>
  </div>
  <div v-else class="not-found-container">
    <h4 class="not-found pt-0">Applicant Not Found</h4>
    <button type="button" class="btn btn-cp mt-3" @click="goBack">
      Go Back to Applicant List
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApplicantInfo from "./applicant-info.vue";
import RoundInfo from "./round-info.vue";
import CommentsSection from "./comments-section.vue";
import EmailConversation from "./email-conversation.vue";
import FollowUpStatus from "./follow-up-status.vue";
import PERMISSIONS from "../../Common/permissions";
import { hasAccess } from "../../User/_utils/actions";
/**
 * @memberOf module:ApplicantProfile
 * @namespace components.applicant_profile
 * @description Applicant Profile component
 */
export default {
  components: {
    ApplicantInfo,
    RoundInfo,
    CommentsSection,
    EmailConversation,
    FollowUpStatus,
  },
  computed: {
    PERMISSIONS() {
      return PERMISSIONS;
    },
    ...mapGetters({
      loggedInUser: "user/loggedInUser",
      applicantInfoData: "$_applicant_profile/fetchApplicantData",
    }),
  },
  methods: {
    hasAccess({ permissions, checkAll }) {
      return hasAccess({ permissions, checkAll });
    },
    goBack() {
      this.$router.replace({ name: "applicants", query: { status: "A" } });
    },
  },
  created() {
    this.$store.dispatch(
      "$_applicant_profile/fetchApplicantData",
      this.$route.params.slug
    );
  },
};
</script>

<style>
.not-found-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.not-found {
  display: flex;
  justify-content: center;
}
</style>
